import { motion } from "framer-motion";

export default function ProblemSolution() {
 return (
 <section
 data-testid="problem-solution"
 id="story"
 className="relative bg-ink-900 py-24 md:py-36"
 >
 <div className="max-w-7xl mx-auto px-4 md:px-8 grid md:grid-cols-12 gap-10">
 <motion.div
 initial={{ opacity: 0, y: 20 }}
 whileInView={{ opacity: 1, y: 0 }}
 viewport={{ once: true }}
 transition={{ duration: 0.6 }}
 className="md:col-span-7"
 >
 <p className="tag-kicker">The hard truth</p>
 <h2 className="font-display text-4xl md:text-6xl font-bold leading-[1.15] tracking-normal mt-4">
 Why your songs <br className="hidden md:block" />
 <span className="text-amber italic">aren't getting synced.</span>
 </h2>
 </motion.div>

 <motion.div
 initial={{ opacity: 0, y: 20 }}
 whileInView={{ opacity: 1, y: 0 }}
 viewport={{ once: true }}
 transition={{ duration: 0.6, delay: 0.1 }}
 className="md:col-span-5 md:pt-8 space-y-6 text-white/70 text-lg leading-relaxed"
 >
 <p>
 You've been working hard. Crafting songs. Attending conferences.
 Submitting tracks. And still. No consistent syncs and no high-value
 rep deals.
 </p>
 <p>
 Even if a supervisor opens the door, if the song isn't right, it
 won't get placed. Wrong production, missing emotional impact, or
 misreading the business side costs indie creators{" "}
 <span className="text-amber font-semibold">
 thousands of dollars
 </span>{" "}
 in missed opportunity and credibility.
 </p>
 <p className="text-white font-medium">
 This is exactly what we help you fix.
 </p>
 </motion.div>
 </div>
 </section>
 );
}
